import React from 'react';
import PropTypes from 'prop-types';
import {
  List,
  Filter,
  Datagrid,
  DateField,
  ReferenceArrayInput,
  ReferenceField,
  TextField,
  FunctionField,
  SelectArrayInput,
  TextInput
} from 'admin-on-rest/lib/mui';
import FlatButton from 'material-ui/FlatButton';
import { Link } from 'react-router-dom';
import EditIcon from 'material-ui/svg-icons/image/edit';
import DataField from './components/DataField';

const EditContactButton = ({ record }) => (
  <FlatButton
    primary
    label="Edit"
    icon={<EditIcon />}
    containerElement={
      <Link
        to={{
          pathname: `/call/${record.contact}`
        }}
      />
    }
  />
);

EditContactButton.propTypes = {
  record: PropTypes.shape({
    contact: PropTypes.number
  })
};

const CallFilter = props => (
  <Filter {...props}>
    <TextInput
      label="Search all"
      source="q"
      alwaysOn
      format={data => (data || '').trim()}
    />
    <TextInput
      label="Numbers"
      source="re"
      alwaysOn
      format={data => (data || '').trim()}
    />
    {permissions =>
      permissions === 'admin' && (
        <ReferenceArrayInput
          label="Agent"
          source="user"
          reference="users"
          filterToQuery={searchText => ({ username: searchText + '%' })}
        >
          <SelectArrayInput
            optionText={r => `${r.username}`}
            options={{ onBlur: () => {} }}
          />
        </ReferenceArrayInput>
      )
    }
    <ReferenceArrayInput
      label="Project"
      source="project"
      reference="projects"
      filterToQuery={searchText => ({ name: searchText })}
    >
      <SelectArrayInput
        optionText={r => `${r.name}`}
        options={{ onBlur: () => {} }}
      />
    </ReferenceArrayInput>
    {permissions =>
      permissions === 'admin' && (
        <ReferenceArrayInput
          label="Contact"
          source="contact"
          reference="contacts"
          filterToQuery={searchText => ({
            or: [
              { firstName: { like: `${searchText}%` } },
              { lastName: { like: `${searchText}%` } },
              { email: { like: `${searchText}%` } },
              { phone: { like: `${searchText}%` } }
            ]
          })}
        >
          <SelectArrayInput
            optionText={r => `${r.id} ${r.firstName || ''} ${r.lastName || ''}`}
            options={{ onBlur: () => {} }}
          />
        </ReferenceArrayInput>
      )
    }
  </Filter>
);
export const CallList = props => (
  <List
    title="Calls"
    {...props}
    filters={<CallFilter />}
    sort={{ field: 'createdAt', order: 'DESC' }}
  >
    {permissions => (
      <Datagrid>
        <ReferenceField
          label="Agent"
          source="user"
          reference="users"
          linkType={false}
          allowEmpty
        >
          <TextField source="username" />
        </ReferenceField>
        <ReferenceField
          label="Project"
          source="project"
          reference="projects"
          linkType={false}
          allowEmpty
        >
          <TextField source="name" />
        </ReferenceField>
        <ReferenceField
          label="Contact"
          source="contact"
          reference="contacts"
          linkType={false}
          allowEmpty
        >
          <DataField label="Name" />
        </ReferenceField>
        <DateField source="createdAt" label="Date created" showTime />

        {permissions === 'agent' && <EditContactButton />}
      </Datagrid>
    )}
  </List>
);



// WEBPACK FOOTER //
// ./src/calls.js